import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationServiceFunctionToggleFavouritePut = {
    path: "/template/service/functions/toggleFavourite",
    method: ERouteHttpVerb.PUT
};
export { routeLocationServiceFunctionToggleFavouritePut };
